function scrollToTop() {

const toTopButton = document.querySelector('.scrollTo');

    if (toTopButton) {
        toTopButton.addEventListener('click', function (e) {
            e.preventDefault();
            window.scrollTo({
                top: 0, behavior: 'smooth'
            });
        });
    }

}

export default scrollToTop;